import { render } from "./HelpAhsVdhVRIMS.vue?vue&type=template&id=1998de16&scoped=true"
import script from "./HelpAhsVdhVRIMS.vue?vue&type=script&lang=js"
export * from "./HelpAhsVdhVRIMS.vue?vue&type=script&lang=js"

import "./HelpAhsVdhVRIMS.vue?vue&type=style&index=0&id=1998de16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1998de16"]])

export default __exports__